<template>
  <div class="flex items-center content-center justify-center p-40">
    <SegmentedControl :tabs="tabs" />
  </div>
</template>

<script>
import SegmentedControl from "@/components/general/SegmentedControl";
export default {
  name: "Components",
  data() {
    return {
      tabs: [
        {
          name: "Pending Sales",
          type: "pending"
        },
        {
          name: "Processing Sales",
          type: "occuring"
        },
        {
          name: "Completed Sales",
          type: "complete"
        },
        {
          name: "Deleted Sales",
          type: "deleted"
        }
      ]
    };
  },
  components: { SegmentedControl },
  methods: {}
};
</script>
